"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ErrorMessage = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../../Elements/Button/Button");
var _Title = require("../../Elements/Title/Title");
var _Text = require("../../Elements/Text/Text");
var _pictogram = _interopRequireDefault(require("../../Elements/pictogram/pictogram"));
var _jsxRuntime = require("react/jsx-runtime");
const ErrorMessage = ({
  data,
  codeLabel,
  errorResponse,
  handleCallback,
  mode,
  ...props
}) => {
  const {
    image,
    title,
    text,
    buttons
  } = data[mode];
  const {
    src,
    alt,
    width,
    pictogramName
  } = image;

  // does an error code/response exist?
  const errorCode = errorResponse && `<b className="ccl-c-error-message__code-label">${codeLabel}:</b> <span className="ccl-c-error-message__code-response">${errorResponse}</span>`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "ccl-c-error-message",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "ccl-c-error-message__content",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("figure", {
        className: "ccl-c-error-message__image",
        children: [src && !pictogramName && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: src,
          alt: alt,
          style: {
            width
          }
        }), pictogramName && /*#__PURE__*/(0, _jsxRuntime.jsx)(_pictogram.default, {
          name: pictogramName,
          customWidth: width
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "ccl-c-error-message__text",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Title.Title, {
          content: title,
          tag: "h1",
          size: "heading-3"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
          content: text,
          type: "body-text",
          isHTML: true
        })]
      }), errorResponse && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "ccl-c-error-message__text--code",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.Text, {
          content: errorCode,
          type: "body-text",
          isHTML: true
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-c-error-message__button-control",
      children: buttons.map(button => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        link: button.link,
        icon: button.icon,
        useCallback: button.useCallback,
        text: button.text,
        variant: button.variant,
        name: button.name,
        action: button.action,
        handleCallback: handleCallback
      }, button.name))
    })]
  });
};
exports.ErrorMessage = ErrorMessage;
ErrorMessage.defaultProps = {
  codeLabel: '',
  errorResponse: '',
  handleCallback: () => {},
  mode: ''
};